import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./user/reducer";
import businessProfileReducer from "./businessProfile/reducer";
import handbooksReducer from "./handbooks/reducer";
import notificationReducer from "./notifications/reducer";
import plansReducer from "./plans/reducer";
import locksReducer from "./locks/reducer";

const rootStore = configureStore({
  reducer: {
    user: userReducer,
    businessProfile: businessProfileReducer,
    handbooks: handbooksReducer,
    notifications: notificationReducer,
    plans: plansReducer,
    locks: locksReducer,
  },
});

export type RootState = ReturnType<typeof rootStore.getState>;
export type AppDispatch = typeof rootStore.dispatch;
export default rootStore;
